import { BiddingData } from 'store/modules/bidding_store/types';
import { BulletinBiddingsTypes } from 'store/modules/bulletins_store/types';

type RobotBidding = BiddingData | BulletinBiddingsTypes;

const buildComprasNetParams = (bidding: RobotBidding): string => {
  const extractUrl = bidding.electronic_trading?.trading_extract_url ?? '';
  const isCompraCode = /^\d{17}$/.test(extractUrl) && ['05', '06'].includes(extractUrl.slice(6, 8));

  const prgCod = isCompraCode ? extractUrl.slice(0, 6) : bidding.electronic_trading.uasg;
  const biddingIdentifier = isCompraCode
    ? extractUrl.slice(8).replace(/^0+/, '')
    : bidding.edital.match(/\d+/g)?.join('');

  return `portal=compras_net&prgCod=${prgCod}&biddingIdentifier=${biddingIdentifier}&modality=${bidding.modality.nome}`;
};

export const buildRobotProposalParams = (bidding: RobotBidding): string => {
  const urlMapping: { [key: number]: () => string } = {
    146: () => buildComprasNetParams(bidding),
    6759: () => buildComprasNetParams(bidding),
    857: () =>
      `portal=compras_publicas&biddingIdentifier=${bidding.electronic_trading.trading_id}&modality=${bidding.modality.nome}`,
    5204: () =>
      `portal=licita_net&biddingIdentifier=${bidding.electronic_trading.trading_id}&modality=${bidding.modality.nome}`,
    677: () =>
      `portal=bll&biddingIdentifier=${bidding.electronic_trading?.trading_extract_url}&idConlicita=${bidding?.bidding_id}&prgCod=${bidding.electronic_trading?.edital}&modality=${bidding.modality.nome}&orgName=${bidding.electronic_trading?.promoter}&city=${bidding.orgao_cidade}&state=${bidding.orgao_estado}`,
    3926: () =>
      `portal=bnc&biddingIdentifier=${bidding.electronic_trading?.trading_extract_url}&idConlicita=${bidding?.bidding_id}&prgCod=${bidding.electronic_trading?.edital}&modality=${bidding.modality.nome}&orgName=${bidding.electronic_trading?.promoter}&city=${bidding.orgao_cidade}&state=${bidding.orgao_estado}`,
  };

  return urlMapping[bidding.electronic_trading.source_id]?.() ?? '';
};
